// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1_RhK","tooltipContent":"Tag_tooltipContent__Obj26"};